import { AxiosRequestConfig } from 'axios';
import { EPSVoidData } from 'src/common/interfaces/dtos/ITenderCancel';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const lineTenderCancel = async (
  lineTenderToCancel: ITenderCancelDto,
  transactionId: string,
): Promise<CartResponse> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/tenders/void`,
    method: 'POST',
    data: lineTenderToCancel,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<CartResponse>(emeraldRequestParams);
};

export const lineRefundCancel = async (
  lineTenderToCancel: ITenderCancelDto,
  transactionId: string,
): Promise<CartResponse> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/returns/${transactionId}/refund`,
    method: 'DELETE',
    data: lineTenderToCancel,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<CartResponse>(emeraldRequestParams);
};

export interface ITenderCancelDto {
  tenderSequenceNumber?: number;
  isProcessedByEps?: boolean;
  transactionSequenceNumber: number;
  epsData?: EPSVoidData;
}
